var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Error',[[_c('span',{staticClass:"error-logo"},[_vm._v("500")]),_c('p',{staticClass:"error-text"},[_vm._v("Unexpected error please contact the administration")]),_c('p',{staticClass:"error-subtext"},[_vm._v("But we're here to bring you back to safety")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }